import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const storeApi = createApi({
  reducerPath: 'storeApi',
  baseQuery: fetchBaseQuery({ baseUrl: "/api/" }),
  endpoints: (builder) => ({
    createNewstore: builder.mutation({
      query: (body) => {
        return {
          url: '/store/new',
          method: "POST",
          body,
        };
      },
    }),
    getAllStores: builder.query({
        query: () => `/stores`, // Simple endpoint without ID
        providesTags: ['Stores']
    }),
    deleteStore: builder.mutation({
      query: (id) => {
        return {
          url: `/store/delete/${id}`, // Use the id in the URL
          method: "DELETE",
        };
      },
    }),
    // New mutation for updating a store
    updateStore: builder.mutation({
      query: ({ id, ...body }) => {
        return {
          url: `/store/update/${id}`,
          method: "PUT",
          body,
        };
      },
      // Invalidate the Stores tag to refetch store list after update
      invalidatesTags: ['Stores']
    }),
    // New query for getting a specific store by ID
    getStore: builder.query({
      query: (id) => `/store/${id}`,
      // Provide a tag with the specific store ID for more precise caching
      providesTags: (result, error, id) => [{ type: 'Store', id }]
    }),
  }),
});

// Export the auto-generated hooks for the mutations and queries
export const { 
  useCreateNewstoreMutation, 
  useGetAllStoresQuery, 
  useDeleteStoreMutation,
  useUpdateStoreMutation, // New hook for updating a store
  useGetStoreQuery // New hook for getting a specific store
} = storeApi;